import { PaymentTermsResult, PaymentTermsSearch } from "@/types/PaymentTerms";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

interface PaymentTermsResponse {
  name: string;
  user_id: number;
  number_of_day: number;
  id: number;
}

export const paymentTermsApi = createApi({
  reducerPath: "paymentTermsApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["paymentTerms"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    // getVendorById: builder.query<any, string>({
    //   query: (id) => `/payment-terms/${id}`,
    //   providesTags: ["paymentTerms"],
    // }),

    // searchVendors: builder.query<VendorSearchResult, VendorSearch>({
    //   query: (input) => ({
    //     url: `/payment-terms/search`,
    //     method: "POST",
    //     body: input,
    //   }),
    //   providesTags: ["paymentTerms"],
    // }),

    getAllPaymentTerms: builder.query<PaymentTermsResponse[], any>({
      query: () => `/payment-terms`,
      providesTags: ["paymentTerms"],
    }),

    searchPaymentTerms: builder.query<PaymentTermsResult, PaymentTermsSearch>({
      query: (input) => ({
        url: `/payment-terms/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["paymentTerms"],
    }),

    getPaymentTermsById: builder.query<any, number>({
      query: (id) => `/payment-terms/${id}`,
      providesTags: ["paymentTerms"],
    }),

    createPaymentTerms: builder.mutation<void, any>({
      query: (input) => ({
        url: `/payment-terms`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["paymentTerms"],
    }),
    updatePaymentTerms: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/payment-terms/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["paymentTerms"],
    }),
  }),
});

export const {
  useGetAllPaymentTermsQuery,
  useSearchPaymentTermsQuery,
  useGetPaymentTermsByIdQuery,
  useCreatePaymentTermsMutation,
  useUpdatePaymentTermsMutation,
} = paymentTermsApi;
